import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { FramePage } from './frame/frame.page';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
    {
        path: '',
        component: FramePage,
        children: [
            {
                path: '',
                component: HomeComponent
            },
            {
                path: 'assinatura',
                loadChildren: () => import('./modules/assinatura/assinatura.module').then(m => m.AssinaturaModule)
            }
        ]
    }
];

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }